import React, { useEffect, useState } from 'react';

export default function CarModel() {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoaded(true), 500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div 
      className="car-model-container relative h-[400px] lg:h-[500px] flex items-center justify-center overflow-hidden rounded-2xl"
      data-testid="hero-image-container"
    >
      {/* Main shop image */}
      <div className={`relative w-full h-full transition-all duration-1000 ${isLoaded ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`}>
        <img 
          src="https://customer-assets.emergentagent.com/job_glass-repair-tech/artifacts/eyyqk6tc_WhatsApp%20Image%202026-02-19%20at%201.30.10%20PM%20%282%29.jpeg"
          alt="Doon Auto Glass - AIS Exclusive Glass Shopee"
          className="w-full h-full object-cover rounded-2xl"
          onLoad={() => setIsLoaded(true)}
        />
        
        {/* Gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-transparent to-transparent rounded-2xl"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-[#050505]/50 via-transparent to-transparent rounded-2xl"></div>
        
        {/* Glowing border effect */}
        <div className="absolute inset-0 rounded-2xl border border-cyan-500/30 shadow-[0_0_30px_rgba(0,212,255,0.2)]"></div>
        
        {/* AIS Badge */}
        <div className="absolute bottom-4 right-4 glass-card px-4 py-2 rounded-lg flex items-center gap-2">
          <span className="text-cyan-400 font-orbitron text-sm font-bold">AIS</span>
          <span className="text-gray-400 text-xs">Authorized Dealer</span>
        </div>
      </div>

      {/* Floating glass shards decoration */}
      {[...Array(6)].map((_, i) => (
        <div
          key={i}
          className="absolute pointer-events-none"
          style={{
            left: `${10 + Math.random() * 80}%`,
            top: `${10 + Math.random() * 80}%`,
            animation: `float ${3 + Math.random() * 2}s ease-in-out infinite`,
            animationDelay: `${Math.random() * 2}s`
          }}
        >
          <div 
            className="w-3 h-3 md:w-4 md:h-4 bg-gradient-to-br from-cyan-400/20 to-blue-500/10 border border-cyan-500/20"
            style={{
              clipPath: 'polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%)',
              transform: `rotate(${Math.random() * 360}deg)`
            }}
          />
        </div>
      ))}

      {/* Corner decorations */}
      <div className="absolute top-0 left-0 w-20 h-20 border-l-2 border-t-2 border-cyan-500/30 rounded-tl-2xl"></div>
      <div className="absolute bottom-0 right-0 w-20 h-20 border-r-2 border-b-2 border-cyan-500/30 rounded-br-2xl"></div>

      {/* Loading state */}
      {!isLoaded && (
        <div className="absolute inset-0 flex items-center justify-center bg-[#0A0A0A] rounded-2xl">
          <div className="text-center">
            <div className="w-12 h-12 border-2 border-cyan-500 border-t-transparent rounded-full animate-spin mx-auto mb-3"></div>
            <p className="text-gray-400 font-orbitron text-xs tracking-wider">LOADING</p>
          </div>
        </div>
      )}
    </div>
  );
}
